var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"hide-details":"","label":_vm.label,"items":_vm.items,"item-text":"Kod","item-value":"Kod"},model:{value:(_vm.Model),callback:function ($$v) {_vm.Model=$$v},expression:"Model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }